import { Card, Tree } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line max-len
import { type AudiCalculationModuleSettingDataFragment } from '../../../../../api/fragments/AudiCalculationModuleSettingData';
import { type AudiCalculationModuleSpecsFragment } from '../../../../../api/fragments/AudiCalculationModuleSpecs';
import NoItemResult from '../../../../../components/results/NoItemResult';
import useTranslatedString from '../../../../../utilities/useTranslatedString';

type AudiCalculationSettingTabInsuranceProductProps = {
    module: AudiCalculationModuleSpecsFragment;
    setting: AudiCalculationModuleSettingDataFragment;
};

const AudiCalculationSettingTabInsuranceProduct = ({
    module,
    setting,
}: AudiCalculationSettingTabInsuranceProductProps) => {
    const { t } = useTranslation(['audiCalculationModuleDetails']);
    const translatedString = useTranslatedString();

    const treeData = useMemo(
        () =>
            setting.insuranceProducts.map(insurer => ({
                key: insurer.id,
                title: translatedString(insurer.legalName),
            })),
        [setting.insuranceProducts, translatedString]
    );

    if (treeData.length === 0) {
        return <NoItemResult subTitle={t('audiCalculationModuleDetails:tabs.insuranceProducts.noData')} />;
    }

    return (
        <Card>
            <Tree selectable={false} treeData={treeData} defaultExpandAll />
        </Card>
    );
};

export default AudiCalculationSettingTabInsuranceProduct;
